import { render } from "./RefundPolicyPage.vue?vue&type=template&id=315d3b33&scoped=true"
import script from "./RefundPolicyPage.vue?vue&type=script&lang=js"
export * from "./RefundPolicyPage.vue?vue&type=script&lang=js"

import "./RefundPolicyPage.vue?vue&type=style&index=0&id=315d3b33&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-315d3b33"]])

export default __exports__